import { actionCreators as FeedItemActionCreators } from '@app/components/FeedItem/modules/feedItems'
import { shareAttachmentActionCreators } from '@app/components/ShareAttachmentModal/modules/shareAttachment'
import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import ListingPage from '../components/ListingPage'
import {
  actionCreators,
  IListingState,
  selectError,
  selectIsDeleting,
  selectIsLoading,
  selectListing,
  selectPermissions,
  selectShowConfirmDelete,
} from '../modules/listing'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      IListingState & ICurrentUserState
    >({
      error: selectError(),
      isDeleting: selectIsDeleting(),
      isLoading: selectIsLoading(),
      listing: selectListing(),
      permissions: selectPermissions(),
      showConfirmDelete: selectShowConfirmDelete(),
      user: selectCurrentUser(),
    }),
    {
      ...actionCreators,
      ...shareAttachmentActionCreators,
      ...FeedItemActionCreators,
    },
  )(ListingPage),
)
